import { createApi } from '@reduxjs/toolkit/query/react';
import { safeBaseQuery } from './functions';
import { InitDto } from '../../types/common';

const common = createApi({
    reducerPath: 'apiCommon',
    baseQuery: safeBaseQuery('common'),
    endpoints: (builder) => ({
        init: builder.query<InitDto, void>({
            query: () => `/init`,
        }),
    }),
});

export const { useInitQuery, useLazyInitQuery } = common;
export default common;
